import { useRef } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useHotkeys } from 'react-hotkeys-hook'

import IconLink from 'components/Shared/IconLink/Index'
import colors from 'components/utils/colors'

const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

const StyledSearchInput = styled.input`
  font-size: 14px;
  width: 240px;
  height: 24px;
  padding: 0 ${props => !props.value ? '22px' : '45px'} 0 8px;
  border: 1px solid ${colors.secondary70};
  border-radius: 3px;
  cursor: text;
  color: ${colors.secondary20};
  -webkit-appearance: none;

  &::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: ${colors.secondary70};
  }

  &:focus {
    outline-style: none;
    border-color: ${colors.primary40};
  }
`

const StyledClearButton = styled(IconLink)`
  position: absolute;
  right: 24px;
  padding: 0 6px;
`

const StyledSearchButton = styled(IconLink)`
  position: absolute;
  right: 4px;
  padding: 0 4px;
`

const TransparentGradient = styled.div`
  position: absolute;
  pointer-events: none;
  width: 32px;
  top: 1px;
  bottom: 1px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  right: ${props => !props.value ? '22px' : '35px'};
}`

const SearchInput = ({
  autoFocus, value, onChange, onClear, onSearch,
  onKeyPress, onKeyDown, placeholder, withHotKeys, inputRef,
}) => {
  const internalRef = useRef(null)
  const searchInput = inputRef || internalRef

  const handleFocus = () => {
    searchInput.current.focus()
  }

  useHotkeys('/', (e) => {
    handleFocus()
  }, {
    useKey: true,
    enabled: !!withHotKeys,
  })

  return (
    <InputWrapper>
      <StyledSearchInput
        ref={searchInput}
        id='search'
        autoFocus={autoFocus}
        type='search'
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        autoComplete='search'
        onKeyDown={onKeyDown}
      />
      <TransparentGradient value={value} />
      {!!value && <StyledClearButton iconName='icon-clear-search' onClick={onClear} />}
      <StyledSearchButton iconName='icon-search' onClick={onSearch} />
    </InputWrapper>
  )
}


SearchInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  withHotKeys: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  inputRef: PropTypes.object,
}

export default SearchInput
